import type { DesktopAppBranding } from "@t3tools/contracts";
import { DEFAULT_WEB_PRODUCT_BRANDING } from "./buildBranding";
import { formatAppDisplayName } from "./branding.logic";

function readInjectedDesktopAppBranding(): DesktopAppBranding | null {
  if (typeof window === "undefined") {
    return null;
  }

  return window.desktopBridge?.getAppBranding() ?? null;
}

const injectedDesktopAppBranding = readInjectedDesktopAppBranding();
const hostedAppChannel = import.meta.env.VITE_HOSTED_APP_CHANNEL?.trim().toLowerCase();
const configuredAppName =
  import.meta.env.VITE_APP_NAME?.trim() || DEFAULT_WEB_PRODUCT_BRANDING.name;

export const HOSTED_APP_CHANNEL =
  hostedAppChannel === "latest" || hostedAppChannel === "nightly" ? hostedAppChannel : null;
export const HOSTED_APP_CHANNEL_LABEL =
  HOSTED_APP_CHANNEL === "nightly" ? "Nightly" : HOSTED_APP_CHANNEL === "latest" ? "Latest" : null;
export const APP_BASE_NAME = injectedDesktopAppBranding?.baseName ?? configuredAppName;
export const APP_LOGO_URL =
  import.meta.env.VITE_APP_LOGO_URL?.trim() || DEFAULT_WEB_PRODUCT_BRANDING.logoUrl;
export const APP_STAGE_LABEL =
  injectedDesktopAppBranding?.stageLabel ??
  HOSTED_APP_CHANNEL_LABEL ??
  (import.meta.env.DEV ? "Dev" : "Beta");
export const APP_DISPLAY_NAME =
  injectedDesktopAppBranding?.displayName ??
  (injectedDesktopAppBranding
    ? formatAppDisplayName({ baseName: APP_BASE_NAME, stageLabel: APP_STAGE_LABEL })
    : APP_BASE_NAME);
export const APP_VERSION = import.meta.env.APP_VERSION || "0.0.0";
export const TOLT_AGENT_AUTH_ENABLED =
  import.meta.env.VITE_TOLT_AGENT_AUTH_ENABLED?.trim().toLowerCase() === "true";
export { DESKTOP_DOWNLOAD_URL } from "./lib/desktopDownload";
